/*
 * @Author: xinxinfeng 2273234784@qq.com
 * @Date: 2024-07-01 14:11:23
 * @LastEditors: xinxinfeng 2273234784@qq.com
 * @LastEditTime: 2024-07-04 15:47:26
 * @FilePath: \crane-safety-manager\src\Common\ProfileStyle.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { styled } from 'styled-components';
import { themecolor } from '../../src/config';
import ProfileCover from '../assets/images/profile.png';
import { Avatar } from 'antd';

const StyleProfileCover = styled.div`
    background: url(${ProfileCover}) no-repeat center/ 100% 100%;
    padding: 22px;
    height: 160px;
    border-radius:${themecolor.token.borderRadius}px ${themecolor.token.borderRadius}px 0 0;
`;

const StyleProfileContent = styled.div` 
    position: relative;
    margin-top:-50px;
    display: flex;
    align-items: end;
    gap: 10px;

    .subtitle {
        color: ${({ theme }) => theme.token.colorTextDescription};
    }

    .button-end {
        margin-left: auto;
    }
    
    svg {
        margin-right: 5px;
        vertical-align: middle;
    }
`;

const StyleAvatar = styled(Avatar)` 
    position: relative;
    border: 3px solid ${({ theme }) => theme.token.colorBgContainer};
`;


export { StyleProfileCover, StyleAvatar, StyleProfileContent };